import { useState, useRef } from "react";
import { X, Plus } from "lucide-react";

export default function TagsInput({ value = [], onChange, testid = "tags-input", placeholder = "persona:cto, campaign:q1, ..." }) {
  const [draft, setDraft] = useState("");
  const inputRef = useRef(null);

  const add = (raw) => {
    const t = (raw || "").trim().replace(/,$/, "").trim();
    if (!t) return;
    if (value.includes(t)) { setDraft(""); return; }
    onChange?.([...value, t]);
    setDraft("");
  };
  const remove = (idx) => {
    const next = value.slice();
    next.splice(idx, 1);
    onChange?.(next);
  };

  return (
    <div
      className="cf-input flex flex-wrap gap-2 items-center min-h-[42px] cursor-text"
      onClick={() => inputRef.current?.focus()}
      data-testid={testid}
      style={{ padding: "6px 10px" }}
    >
      {value.map((t, i) => (
        <span
          key={`${t}-${i}`}
          className="inline-flex items-center gap-1 px-2 py-0.5 bg-zinc-900 border border-zinc-700 text-xs font-mono text-zinc-200"
          data-testid={`${testid}-tag-${i}`}
        >
          {t}
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); remove(i); }}
            className="text-zinc-500 hover:text-[#E23A28]"
            data-testid={`${testid}-tag-${i}-remove`}
            aria-label={`Remove ${t}`}
          >
            <X size={11} />
          </button>
        </span>
      ))}
      <input
        ref={inputRef}
        type="text"
        value={draft}
        onChange={(e) => {
          const v = e.target.value;
          if (v.endsWith(",")) add(v);
          else setDraft(v);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === "Tab") {
            if (draft.trim()) { e.preventDefault(); add(draft); }
          } else if (e.key === "Backspace" && !draft && value.length) {
            remove(value.length - 1);
          }
        }}
        onBlur={() => draft.trim() && add(draft)}
        className="flex-1 min-w-[140px] bg-transparent outline-none border-0 text-sm text-white placeholder-zinc-600"
        placeholder={value.length === 0 ? placeholder : ""}
        data-testid={`${testid}-field`}
      />
      {draft && (
        <button
          type="button"
          onClick={() => add(draft)}
          className="text-zinc-500 hover:text-white"
          data-testid={`${testid}-add`}
          aria-label="Add tag"
        >
          <Plus size={14} />
        </button>
      )}
    </div>
  );
}
